import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'theme-dark': _vm.isDarkMode},attrs:{"id":"app"}},[_c(VApp,[_c('Toolbar',{on:{"dark-mode-changed":_vm.updateDarkMode}}),_c(VContent,{staticClass:"app-content"},[_c('Content')],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }